import { Link } from '@tanstack/react-router';
import { type ShipmentStatusCount } from '@uturn/api/v1';
import { useTranslation } from 'react-i18next';
import { SHIPMENT_STATUS_GROUPINGS } from './constants';
import { type ShipmentGroupCardTileProps } from './shipment-group-status-tile.types';
import { getShipmentCount, getShipmentStatusLinkProps } from './utils';

export function ShipmentGroupStatusTile({
	id,
	shipmentsStatusCount,
	shipmentStatus,
	handleOnClick,
}: ShipmentGroupCardTileProps) {
	const { t } = useTranslation();

	const row: Required<ShipmentStatusCount> = {
		shipmentStatus,
		count: getShipmentCount(
			shipmentsStatusCount,
			SHIPMENT_STATUS_GROUPINGS[shipmentStatus],
		),
	};

	const linkProps = getShipmentStatusLinkProps(id)[shipmentStatus];

	return (
		<Link
			{...linkProps}
			className="z-10"
			onClick={(event) => handleOnClick({ ...linkProps, event })}
		>
			<div className="w-24 rounded bg-secondary px-3 py-2 text-left">
				<h4 className="flex flex-col">
					<span className="text-sm text-muted-foreground">
						{t(
							`pages.shipments.groups.overview.card.status-tile.${row.shipmentStatus}`,
							'Archived',
						)}
					</span>
					<span className="text-3xl font-bold leading-8 tracking-tight">
						{row.count}
					</span>
				</h4>
			</div>
		</Link>
	);
}
